/**
 * The homepage hero carousel.
 *
 * THIS BEHAVIOUR WAS MISSING ENTIRELY. The markup shipped — `#heroSlides`,
 * `.hero__dot`, `#heroPrev`, `#heroNext` — but the code lived in
 * `assets/theme.js`, which the rebuild does not ship. Arrows, dots, autoplay and
 * swipe were all dead. The footer accordion was lost the same way.
 *
 * Neither the parity harness nor a screenshot could catch it: `capture.mjs`
 * stubs `setInterval` before page scripts (a running carousel makes every
 * capture a different image) and never clicks anything. A dead hero showing
 * slide 1 and a working hero showing slide 1 are the same picture.
 *
 * It was also missed by a grep: searching hero.liquid for `heroSlides` returns
 * a hit, but that hit is the markup. Presence of an ID is not evidence of a
 * handler.
 *
 * WHAT CHANGED FROM THE 2025 CODE, beyond re-homing it:
 *
 *   - `((idx % 4) + 4) % 4` is gone. Four was hardcoded, so the fifth slide a
 *     merchant adds would have been unreachable and the dots would desync. The
 *     count now comes from the DOM.
 *   - Autoplay resumes after hover. The original only ever paused; one mouse
 *     movement stopped it for the life of the page. Same bug the review
 *     carousel had.
 *   - Arrows and dots get `aria-disabled`/`aria-selected` kept in step, and the
 *     track exposes its position, so the control is not silent to a screen
 *     reader.
 */
(function () {
  function init() {
    const track = document.getElementById('heroSlides');
    const prev = document.getElementById('heroPrev');
    const next = document.getElementById('heroNext');
    if (!track) return;

    const slides = () => track.querySelectorAll('.hero__slide');
    const dots = () => document.querySelectorAll('.hero__dot');

    let current = 0;
    let timer = null;

    function goTo(idx) {
      const n = slides().length;
      if (!n) return;
      // Derived, never hardcoded — this is the whole point of the fix.
      current = ((idx % n) + n) % n;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots().forEach((d, i) => {
        d.classList.toggle('active', i === current);
        d.setAttribute('aria-selected', String(i === current));
      });
      slides().forEach((s, i) => s.setAttribute('aria-hidden', String(i !== current)));
    }

    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => { stop(); if (slides().length > 1) timer = setInterval(() => goTo(current + 1), 5000); };

    if (prev) prev.addEventListener('click', () => { goTo(current - 1); start(); });
    if (next) next.addEventListener('click', () => { goTo(current + 1); start(); });
    dots().forEach((d) => d.addEventListener('click', () => { goTo(Number(d.dataset.idx) || 0); start(); }));

    // Touch swipe.
    let touchStartX = 0;
    track.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) { goTo(current + (dx < 0 ? 1 : -1)); start(); }
    }, { passive: true });

    // Keyboard, on the arrows' own container — a carousel that only responds to
    // a mouse is not operable.
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { goTo(current - 1); start(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); start(); }
    });

    track.addEventListener('mouseenter', stop);
    track.addEventListener('mouseleave', start);   // the half the original never had
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

    goTo(0);
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
